import { render, staticRenderFns } from "./ReportPdfPage2.vue?vue&type=template&id=4689e4fe&"
import script from "./ReportPdfPage2.vue?vue&type=script&lang=js&"
export * from "./ReportPdfPage2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports